<div class="not-found-container">
  <h2>{{ "global.pageNotFound" | translate }}</h2>
  <h3 class="wrong-route">{{ wrongRoute }}</h3>
  <a class="home-link" [href]="homeUrl">{{
    "global.pageNotFoundLink" | translate
  }}</a>
</div>
